import axios from 'axios'

export const getAllPriceTables = (params) => {
  return axios.get('price-tables', {params: params})
}

export const getPriceTable = (id, params) => {
  return axios.get('price-tables/' + id, {params: params})
}

export const getAllHelpers = (params) => {
  return axios.get('helpers/price-tables', {params: params})
}

export const addPriceTable = (data) => {
  return axios.post('price-tables', data)
}

export const editPriceTable = (id, data) => {
  return axios.put('price-tables/' + id, data)
}

export const deletePriceTable = (id) => {
  return axios.delete('price-tables/' + id)
}

export const restorePriceTable = (id) => {
  return axios.post('price-tables/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/pricetable.js